(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const sectionId = this.getAttribute('data-header-section-id');
      this.header =
        this.closest('.shopify-section.section-header') ||
        (sectionId ? document.getElementById(sectionId) : null) ||
        document.querySelector('.shopify-section.section-header');
      if (!this.header) return;

      document.documentElement.classList.add('sticky-header-enabled');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.header.style.position = 'fixed';
      this.header.style.top = '0';
      this.header.style.left = '0';
      this.header.style.right = '0';
      this.header.style.width = '100%';
      this.header.style.zIndex = '100';

      this.onResizeHandler = this.setHeaderHeight.bind(this);
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.onResizeHandler);
      window.addEventListener('resize', this.onResizeHandler);
      window.addEventListener('scroll', this.onScrollHandler, false);
      document.documentElement.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.onResizeHandler);
        this.resizeObserver.observe(this.header);
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      document.documentElement.removeEventListener('scroll', this.onScrollHandler);
      if (this.onResizeHandler) {
        window.matchMedia('(max-width: 990px)').removeEventListener('change', this.onResizeHandler);
        window.removeEventListener('resize', this.onResizeHandler);
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.headerIsAlwaysSticky) return;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  // Keep the cart count bubble in sync after add-to-cart / cart-drawer / cart-notification
  // events without a full page reload. Guarded so it never throws if pubsub.js /
  // constants.js aren't loaded on a given page.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          const bubble = document.querySelector('.srs-cart-count-bubble');
          const countEl = bubble ? bubble.querySelector('span') : null;

          if (bubble && countEl) {
            countEl.textContent = cart.item_count;
            bubble.classList.toggle('hidden', cart.item_count === 0);
          }
        })
        .catch(function () {});
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-tt-corporate-pass"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target.closest('[data-tt-pass-direct-checkout]');
        if (!form) return;
  
        event.preventDefault();
        event.stopImmediatePropagation();
  
        var button = form.querySelector('.tt-pass-btn__rh');
        if (button) button.disabled = true;
  
        fetch(form.getAttribute('data-clear-url'), {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        })
          .then(function () {
            return fetch(form.getAttribute('data-add-url'), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              credentials: 'same-origin',
              body: JSON.stringify({
                id: Number(form.getAttribute('data-variant-id')),
                quantity: 1
              })
            });
          })
          .then(function (response) {
            if (!response.ok) throw new Error('add');
            window.location.href = form.getAttribute('data-checkout-url');
          })
          .catch(function () {
            form.submit();
          });
      },
      true
    );
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-tt-faq"] && !Shopify.designMode) return;
  try {
    
  function initTtFaq(root) {
    var items = root.querySelectorAll('[data-tt-faq-item]');
    if (!items.length) return;

    function closeItem(item) {
      var panel = item.querySelector('[data-tt-faq-panel]');
      var trigger = item.querySelector('.tt-faq-trigger__rh');
      item.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.style.maxHeight = '0';
    }

    function openItem(item) {
      var panel = item.querySelector('[data-tt-faq-panel]');
      var trigger = item.querySelector('.tt-faq-trigger__rh');
      item.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('.tt-faq-trigger__rh');
      var panel = item.querySelector('[data-tt-faq-panel]');
      if (!trigger || !panel) return;

      if (item.classList.contains('is-open')) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        items.forEach(closeItem);

        if (!isOpen) {
          openItem(item);
        }
      });
    });

    window.addEventListener('resize', function () {
      items.forEach(function (item) {
        if (!item.classList.contains('is-open')) return;
        var panel = item.querySelector('[data-tt-faq-panel]');
        if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
      });
    });
  }

  document.querySelectorAll('[data-tt-faq-root]').forEach(initTtFaq);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-tt-floating-bar-bottom"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest('[data-srs-floating-checkout]');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var button = form.querySelector('.srs-floating-bar-bottom__cta');
      if (button) button.disabled = true;

      fetch(form.getAttribute('data-clear-url'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      })
        .then(function () {
          return fetch(form.getAttribute('data-add-url'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              id: Number(form.getAttribute('data-variant-id')),
              quantity: 1,
            }),
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('add');
          window.location.href = form.getAttribute('data-checkout-url');
        })
        .catch(function () {
          form.submit();
        });
    },
    true
  );

  (function () {
    var bars = document.querySelectorAll('[data-floating-bar-root]');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var triggerId = (bar.getAttribute('data-trigger-id') || '').trim();

      if (!triggerId) {
        bar.classList.add('is-visible');
        return;
      }

      var triggerElement = document.getElementById(triggerId);
      if (!triggerElement) {
        bar.classList.add('is-visible');
        return;
      }

      var updateVisibility = function () {
        var rect = triggerElement.getBoundingClientRect();
        var hasPassedTrigger = rect.bottom <= 0;
        bar.classList.toggle('is-visible', hasPassedTrigger);
      };

      updateVisibility();
      window.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
